import Router from './routes';
import ThemeProvider from './theme';
import Settings from './components/settings';
import { ChartStyle } from './components/chart';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import * as Sentry from "@sentry/react";
import { ClientUIProvider } from "./contexts/ClientUIContext";
import { ClientConfigProvider } from "./contexts/ClientConfigContext";
import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from "react-query/devtools";
import { queryClient } from "./utils/queryClient";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/pro-solid-svg-icons";

library.add(fas);

function FallbackComponent() {
    return <div>An error has occurred :(</div>;
}

const myFallback = () => <FallbackComponent/>;

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <ClientConfigProvider>
                <ClientUIProvider>
                    <ThemeProvider>
                        <ThemeColorPresets>
                            <NotistackProvider>
                                <MotionLazyContainer>
                                    <ProgressBarStyle/>
                                    <ChartStyle/>
                                    <Settings/>
                                    <ReactQueryDevtools initialIsOpen={false}/>
                                    <Sentry.ErrorBoundary fallback={myFallback} showDialog>
                                        <Router/>
                                    </Sentry.ErrorBoundary>
                                </MotionLazyContainer>
                            </NotistackProvider>
                        </ThemeColorPresets>
                    </ThemeProvider>
                </ClientUIProvider>
            </ClientConfigProvider>
        </QueryClientProvider>
    );
}